export default async (
  goveoStoreData,
  { goveoStoreRepository }
) => {
  const goveoStore = await goveoStoreRepository.edit(goveoStoreData);
  return goveoStore;
};
